import { Component, OnInit, AfterViewInit, AfterContentChecked } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../api/services/api.service';

@Component({
  selector: 'app-sys-utilz',
  templateUrl: './app-sys-utilz.component.html',
  styleUrls: ['./app-sys-utilz.component.scss']
})
export class AppSysUtilzComponent implements OnInit, AfterContentChecked {
  public isRefDbActivated: boolean;
  public feedback_link: any;

  constructor(private router: Router, private api: ApiService) {
    this.isRefDbActivated = false;
    this.getFeedback();
  }

  ngOnInit() {
  }

  ngAfterContentChecked() {
    this.isRefDbActivated = this.router.url.startsWith('/references');
  }

  getFeedback() {
    this.api.managerGetFeedBack().subscribe(
      res => {
        let httpString = "http://";
        let httpsString = "https://";
        let feedback_link = res['feedback_link'];
       
        if (feedback_link.substr(0, httpString.length).toLowerCase() !== httpString && feedback_link.substr(0, httpsString.length).toLowerCase() !== httpsString)
                feedback_link = httpString + feedback_link;
        this.feedback_link = feedback_link;
      }
    );
  }

  feedback() {
    window.open(
      this.feedback_link,
      '_blank' // <- This is what makes it open in a new window.
    );
  }

}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/components/app-sys-utilz/app-sys-utilz.component.ts